// selectors.js
import { createSelector } from 'reselect';

const getReadyMStk = (state) => state.ReadyMStkData.singleReadyMStk;
export const selectReadyMStock = createSelector(
  [getReadyMStk],
  (readyMStk) => readyMStk || { data: [] }
);


const getAllReeadyMstk = (state) => state.ReadyMStkData.readyMStk;
export const selectAllReadyMStock = createSelector(
  [getAllReeadyMstk],
  (allReadyMStk) => allReadyMStk || { data: [] }
);

const getReadyBar = (state) => state.ReadyMStkData.readyBar;
export const selectReadyBar = createSelector(
  [getReadyBar],
  (readybar) => readybar || { data: [] }
);


const getCstklumplist = (state) => state.ClothStockData.lumplist;
export const selectCstklump = createSelector(
  [getCstklumplist],
  (lump) => lump || { data: [] }
);

const getClothstklumplist = (state) => state.ClothStockData.onlylump;
export const selectClothstklumplist = createSelector(
  [getClothstklumplist],
  (lump) => lump || { data: [] }
);